export default "__VITE_ASSET__8mpK$PtF__"